/* tslint:disable */
/* eslint-disable */
export enum UnemploymentStatusEnum {
  None = 'None',
  Beneficiary = 'Beneficiary',
  Superannuation = 'Superannuation',
  SelfFunding = 'SelfFunding'
}
